import { useCallback, useContext, useMemo } from 'react';
import { ChannelContext } from '../../context';
import { StoryCardStatus } from '../../services';
import { getEventDiscussionFeed, loadMoreEventDiscussionFeed } from '../../slices';
import { isAdminLayout } from '../utils';
import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';

export const useEventDiscussionFeed = (eventId: number) => {
  const dispatch = useAppDispatch();

  const { page } = useAppSelector(({ eventDiscussionFeed }) => eventDiscussionFeed);

  const { id: channelId } = useContext(ChannelContext).channel;

  const filters = useMemo(() => {
    if (isAdminLayout()) {
      return;
    }

    return { status: [StoryCardStatus.PUBLISHED] };
  }, []);

  const getEventDiscussionFeedItems = useCallback(
    () => dispatch(getEventDiscussionFeed({ channelId, eventId, filters })),
    [channelId, dispatch, eventId, filters]
  );

  const loadMoreEventDiscussionFeedItems = useCallback(
    () => dispatch(loadMoreEventDiscussionFeed({ channelId, eventId, page: page + 1, filters })),
    [channelId, dispatch, eventId, filters, page]
  );

  return { getEventDiscussionFeedItems, loadMoreEventDiscussionFeedItems };
};
